const recursivelyRemoveRefAndData = item => {
  if (typeof item === 'number') {
    return item;
  } else if (Array.isArray(item.data)) {
    if (item.hasOwnProperty('after') || item.hasOwnProperty('before')) {
      const { data, ...rest } = item;
      return {
        data: data.map(recursivelyRemoveRefAndData),
        ...rest
      }
    } else {
      return item.data.map(recursivelyRemoveRefAndData)
    }
  } else {
    return Object.entries(item).reduce((object, [key, value]) => {
      if (key === 'data') {
        object = { ...object, ...recursivelyRemoveRefAndData(value) }
      } else if (Array.isArray(value)) {
        object[key] = value.map(recursivelyRemoveRefAndData)
      } else if (key === 'ref' && value.value && value.value.id) {
        object.id = value.value.id
      } else if (value && typeof value === "object") {
        object[key] = recursivelyRemoveRefAndData(value)
      } else if (key === 'ts') {
        // noop
      } else {
        object[key] = value
      }
      return object;
    }, {})
  }
}

export { recursivelyRemoveRefAndData };